import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './GoogleMapsStatic.css';
import React from 'react'; // eslint-disable-line

import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getPageThemeColors } from '../../../utils';
var GoogleMapStatic = function GoogleMapStatic(_ref) {
  var name = _ref.name,
    lat = _ref.lat,
    long = _ref.long,
    resolution = _ref.resolution,
    zoom = _ref.zoom,
    theme = _ref.theme,
    mapState = _ref.mapState;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var apiKey = canUseDOM && get(window, 'map_key') ? get(window, 'map_key') : 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8';
  var apiStatic = 'https://maps.googleapis.com/maps/api/staticmap?';
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    signaturedMapSrc = _React$useState4[0],
    setSignaturedMapSrc = _React$useState4[1];
  var primaryTheme = get(theme, 'primary', '');
  var primaryColor = getPageThemeColors(isVdsite).primary;
  var pinColor = primaryTheme && primaryTheme !== '--main-color' ? primaryTheme : primaryColor;
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    pinsString = _React$useState6[0],
    setPinString = _React$useState6[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    var newStr = '';
    if (mapState && mapState.markers.length) {
      mapState.markers.forEach(function (pin) {
        if (pin.lat && pin.lng) {
          newStr = "".concat(newStr, "&markers=color:").concat(pinColor.replace('#', '0x'), "%7Clabel:\u2022%7C").concat(pin.lat, ",").concat(pin.lng);
        }
      });
      setPinString(newStr);
    }
    var mapSrc = mapState && mapState.markers.length ? "".concat(apiStatic, "size=").concat(resolution, "&maptype=roadmap").concat(newStr ? newStr : '', "&key=").concat(apiKey) : "".concat(apiStatic, "zoom=").concat(zoom, "&size=").concat(resolution, "&maptype=roadmap&markers=color:").concat(pinColor.replace('#', '0x'), "%7Clabel:\u2022%7C").concat(lat, ",").concat(long, "&key=").concat(apiKey);
    fetch("/api/google/SignedUrl?url=".concat(encodeURIComponent(mapSrc)), {
      method: "GET"
    }).then(function (response) {
      return response.text();
    }).then(function (result) {
      setSignaturedMapSrc(result.startsWith('"') ? result.slice(1, -1) : result);
    });
  }, [name]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, signaturedMapSrc && /*#__PURE__*/React.createElement("img", {
    className: "google-map-static",
    src: signaturedMapSrc,
    alt: name
  }), pinsString ? null : /*#__PURE__*/React.createElement("b", null, "lat lng parameters not provided"));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "  ".concat(eventStyle, "  ").concat(rtl ? rtlStyle : ltlStyle, " "),
    style: {
      width: '100%',
      height: '100%'
    }
  }, children);
};
var eventStyle = "e1e6x71h";
var rtlStyle = "r1xr8nf";
var ltlStyle = "lkfyde2";
export default GoogleMapStatic;